import BaseService from "./BaseService";
import { camelizeKeys } from "humps";

const objectType = "routes";

class RoutesService extends BaseService {
  static getList() {
    return super
      .get("lookup/routes?paginate=false")
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

  static create(data) {
    console.log("DATA!!!!!", data);
    return super
      .post(objectType, `lookup/routes`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {
    return super
      .patch(objectType, `lookup/routes/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super
      .delete(`lookup/routes/${id}`)
      .then((response) => {
        return Promise.resolve({ id });
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }
}

export default RoutesService;
